import api from '@/api';

const resource = 'ei/conceitos';

export default {
  getNiveisEnsino() {
    return api.get('ei/grade/nivelensino');
  },
  getListaGrupoConceitos(data) {
    return api.get(`${resource}`, {
      params: data,
    });
  },
  getGrupoConceitos(id) {
    return api.get(`${resource}/${id}`);
  },
  postGrupoConceitos(data) {
    return api.post(`${resource}`, data);
  },
  putGrupoConceitos(data) {
    return api.put(`${resource}/${data.identificadorgrupoconceito}`, data);
  },
  deleteGrupoConceitos(id) {
    return api.delete(`${resource}/${id}`);
  }
};